import Carousel from './modules/carousel';
import Gallery from './modules/gallery';
import Global from './modules/global';
import Cmp from './modules/cmp';
import Commercial from './modules/commercial';
import Newsletter from './modules/newsletter';
import Multiplex from './modules/multiplex';
import Livenow from './modules/livenow';
import ScrollTracker from './modules/scrolltracker';
import RFVTracker from './modules/rfv';

const modules = {
  Carousel,
  Gallery,
  Global,
  Cmp,
  Commercial,
  Newsletter,
  Multiplex,
  Livenow,
  ScrollTracker,
  RFVTracker
};

var elements = document.querySelectorAll('.js-modules');
if (elements.length > 0) {
  var options = JSON.parse(elements[0].text || elements[0].textContent);
  options.modules.forEach((module) => {
    if (modules[module.name]) {
      new modules[module.name](module.options);
    }
  });
}
